<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>小程序消息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="消息类型">
                    <el-select v-model="listQuery.type" clearable placeholder="请选择" clear filterable>
                        <el-option v-for="(item, index) in typeList" :key="index"
                            :label="'(' + item.type + ')' + item.title+','+item.noticeType" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否已读">
                    <el-select v-model="listQuery.isRead" clearable class="filter-item" placeholder="是否已读">
                        <el-option label="是" value="1" />
                        <el-option label="否" value="0" />
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="是否需要弹窗">
                    <el-select v-model="listQuery.isAlert" clearable class="filter-item" placeholder="是否要弹窗提醒">
                        <el-option label="是" value="1" />
                        <el-option label="否" value="0" />
                    </el-select>
                </el-form-item> -->

                <!-- <el-form-item label="是否需要填写回执信息">
                    <el-select v-model="listQuery.isFeedback" clearable class="filter-item" placeholder="是否需要填写回执信息">
                        <el-option label="是" value="1" />
                        <el-option label="否" value="0" />
                    </el-select>
                </el-form-item> -->

                <el-form-item label="发送时间">
                    <el-date-picker v-model="chooseTime" :picker-options="{}" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>

                <el-form-item label="批次号">
                    <el-input v-model="listQuery.batchNo" placeholder="批次号" clearable></el-input>
                </el-form-item>
                <el-form-item label="服务者编号">
                    <el-input v-model="listQuery.workerNo" placeholder="服务者编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="服务者姓名">
                    <el-input v-model="listQuery.workerName" placeholder="服务者姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="listQuery.title" placeholder="标题" clearable></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" class="el-icon-plus" plan @click="addNotice">发送通知</el-button>
                </el-form-item> -->

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="id" width="55"></el-table-column>
                <!-- <el-table-column prop="batchNo" label="批次号"></el-table-column> -->
                <el-table-column prop="jobId" label="任务编号"></el-table-column>
                <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
                <el-table-column prop="workerName" label="服务者姓名"></el-table-column>
                <el-table-column prop="type" label="消息类型">
                    <template slot-scope="scope">
                        {{ getTypeName(scope.row.type) }}
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <!-- <el-table-column prop="noticeType" label="提醒类型"></el-table-column> -->
                <el-table-column prop="content" label="内容" width="300"></el-table-column>
                <!-- <el-table-column prop="isAlert" label="是否弹窗">
                    <template slot-scope="scope">
                        {{ scope.row.isAlert == 1 ? '是' : '否' }}
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="isFeedback" label="是否要填写回执">
                    <template slot-scope="scope">
                        {{ scope.row.isFeedback == 1 ? '是' : '否' }}
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="feedbackComment" label="回执信息"></el-table-column>
                <el-table-column prop="feedbackImgs" label="图片">
                    <template slot-scope="scope">
                        <span v-if="scope.row.feedbackImgs == ''">无</span>
                        <el-image v-else slot="reference" :preview-src-list="scope.row.feedbackImgs.split(',')"
                            v-for="item in scope.row.feedbackImgs.split(',')" :key="item.index" :src="item"></el-image>
                    </template>
                </el-table-column> -->

                <el-table-column prop="isRead" label="是否已读" width="100" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.isRead == 0 ? '未读' : '已读' }}<br/>
                        <sapn v-if="scope.row.isRead == 1">（{{ scope.row.readType==1?'服务者':'后台人员' }}）</sapn>
                    </template>
                </el-table-column>
                <el-table-column prop="readTime" :formatter="dateFormatA" label="读取时间"></el-table-column>
                <el-table-column prop="sendTime" :formatter="dateFormatA" label="发送时间"></el-table-column>
                <el-table-column prop="sendName" label="创建人"></el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)">删除当前数据
                        </el-button>
                        <el-button type="text" icon="el-icon-edit" @click="handleDelBatch(scope.row)">
                            删除同批次
                        </el-button> -->
                        <el-button v-if="scope.row.isRead == 0" type="text" icon="el-icon-edit" @click="operRead(scope.row)">代替阅读
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>
        <addNoticeCompent @querySearch="querySearch" ref="addNotice" />

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/Pagination";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
import addNoticeCompent from '@/components/messagelog/addNoticeCompent';
let vm;
export default {
    components: { Pagination, addNoticeCompent },
    data() {
        return {

            chooseTime: [],
            listData: [],
            typeList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                batchNo: '',
                workerNo: "",
                workerName: "",
                title: '',
                type: '',
                isRead: '',
                isAlert: '',
                isFeedback: '',
                sendTimeStart: '',
                sendTimeEnd: '',
            },

        };
    },

    created() {
        this.getTypeData();
        this.querySearch();
    },
    methods: {
        operRead(row){
            service.$axioWorkerReadNotice({
                id: row.id,
            }).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.querySearch();
                }
            });
        },
        addNotice() {
            this.$refs.addNotice.showAddView();
        },
        handleDelBatch(row) {
            this.$confirm("是否确认删除同批次消息？批次号：" + row.batchNo, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                service
                    .$axioWorkerNoticeDeleteByBatchNo({
                        batchNo: row.batchNo,
                    })
                    .then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("操作成功");
                            this.querySearch();
                        }
                    });
            })
                .catch(() => { });
        },
        handleDel(row) {
            this.$confirm("是否确认删除消息：(" + row.workerName + ")" + row.content, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                service
                    .$axioWorkerNoticeDeleteById({
                        id: row.id,
                    })
                    .then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("操作成功");
                            this.querySearch();
                        }
                    });
            })
                .catch(() => { });
        },
        getTypeData() {
            service.$axioWorkerNoticeGetTypelist({ level: 2 }).then((res) => {
                if (res.data.errno == 0) {
                    this.typeList = res.data.data;
                }
            })
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;

            this.listQuery.sendTimeStart = '';
            this.listQuery.sendTimeEnd = '';
            if (this.chooseTime.length > 0) {
                this.listQuery.sendTimeStart = this.chooseTime[0];
                this.listQuery.sendTimeEnd = this.chooseTime[1];
            }
            service.$axioWorkerNoticeGetPageList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getTypeName(type) {
            if (type == null || type == '') {
                return '';
            }
            let nm = '';
            this.typeList.forEach(e => {
                if (e.id == type) {
                    nm = e.title;
                }
            })
            return nm;
        },
    },

    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>